import { supabase } from '../lib/supabase';
import { validateUUIDOrThrow } from '../utils/uuidValidator';

export const shipmentItemsService = {
  async getByShipmentId(shipmentId) {
    // ✅ VALIDATION UUID AVANT LA REQUÊTE
    validateUUIDOrThrow(shipmentId, 'ID envoi');
    
    const { data, error } = await supabase?.from('shipment_items')?.select(`
        *,
        catalog_items:catalog_item_id (
          id,
          name,
          category,
          description
        )
      `)?.eq('shipment_id', shipmentId)?.order('created_at', { ascending: true });

    if (error) throw error;

    return data?.map(item => ({
      id: item?.id,
      shipmentId: item?.shipment_id,
      catalogItemId: item?.catalog_item_id,
      catalogItemName: item?.catalog_items?.name,
      catalogItemCategory: item?.catalog_items?.category,
      quantity: item?.quantity,
      priceUnit: parseFloat(item?.price_unit),
      priceTotal: parseFloat(item?.price_total),
      createdAt: item?.created_at,
      updatedAt: item?.updated_at
    }));
  },

  async create(shipmentId, items) {
    // ✅ VALIDATION UUID AVANT LA REQUÊTE
    validateUUIDOrThrow(shipmentId, 'ID envoi');
    
    // Validate catalog item IDs
    items?.forEach((item, index) => {
      validateUUIDOrThrow(item?.catalogItemId, `ID article (élément ${index + 1})`);
    });
    
    const itemsToInsert = items?.map(item => ({
      shipment_id: shipmentId,
      catalog_item_id: item?.catalogItemId,
      quantity: item?.quantity,
      price_unit: item?.priceUnit,
      price_total: item?.priceTotal
    }));

    const { data, error } = await supabase?.from('shipment_items')?.insert(itemsToInsert)?.select();

    if (error) throw error;

    return data?.map(item => ({
      id: item?.id,
      shipmentId: item?.shipment_id,
      catalogItemId: item?.catalog_item_id,
      quantity: item?.quantity,
      priceUnit: parseFloat(item?.price_unit),
      priceTotal: parseFloat(item?.price_total),
      createdAt: item?.created_at,
      updatedAt: item?.updated_at
    }));
  },

  async deleteByShipmentId(shipmentId) {
    // ✅ VALIDATION UUID AVANT LA REQUÊTE
    validateUUIDOrThrow(shipmentId, 'ID envoi');
    
    const { error } = await supabase?.from('shipment_items')?.delete()?.eq('shipment_id', shipmentId);

    if (error) throw error;
  },

  async getTotalByShipmentId(shipmentId) {
    // ✅ VALIDATION UUID AVANT LA REQUÊTE
    validateUUIDOrThrow(shipmentId, 'ID envoi');
    
    const { data, error } = await supabase?.from('shipment_items')?.select('price_total')?.eq('shipment_id', shipmentId);

    if (error) throw error;

    const total = data?.reduce((sum, item) => sum + parseFloat(item?.price_total || 0), 0);
    return total;
  }
};